export default __webpack_public_path__ + "static/media/header image 1.1e918552.jpg";